'use strict';

var scrollAnimate = require('../components/scrollAnimate');

/**
 * This function is used to check if the Back to Top button should be shown or hidden, based on the number of visible product tiles.
 * The visibility threshold is based on the window width, and is set to 4 for desktop, 3 for tablets and 2 for mobile.
 * If the number of visible tiles is greater or equal to the visibility threshold, the Back to Top button will be shown.
 * Otherwise it will be hidden.
 * The function also updates the count of visible tiles in the Back to Top button.
 */
function checkDivsBackToTop() {
    const headerHeight = $('.header').outerHeight() || 0;
    const windowTop = $(window).scrollTop() + headerHeight;
    const windowWidth = $(window).width();
    const backToTopDOM = $('.plp-back-to-top');
    const productTilesDOM = $('.plp-product-tiles');
    const productTilesDOMLength = productTilesDOM.length;
    let visibilityThreshold;
    if (windowWidth >= 1024) {
        visibilityThreshold = 4;
    } else if (windowWidth >= 768 && windowWidth < 1024) {
        visibilityThreshold = 3;
    } else {
        visibilityThreshold = 2;
    }

    if (productTilesDOMLength === 0) {
        backToTopDOM.addClass('d-none').removeClass('d-flex');
        return;
    }

    let visibleTiles = 0;
    let lastTileCount = 0;

    // eslint-disable-next-line consistent-return
    productTilesDOM.each(function () {
        const $elem = $(this);
        const divBottom = $elem.offset().top + $elem.outerHeight();

        if (divBottom < windowTop + headerHeight) {
            visibleTiles += 1;
            lastTileCount = $elem.data('tileCount') || 0;
        } else {
            return false;
        }
    });

    if (visibleTiles >= visibilityThreshold) {
        backToTopDOM.removeClass('d-none').addClass('d-flex');
    } else {
        backToTopDOM.addClass('d-none').removeClass('d-flex');
    }

    $('.plp-back-to-top .tiles-update-count').text(lastTileCount);
}

checkDivsBackToTop();
var scrollTimeout;

$(window).on('scroll', function () {
    clearTimeout(scrollTimeout);

    $('.plp-back-to-top').removeClass('d-none').addClass('d-flex');
    scrollTimeout = setTimeout(function () {
        $('.plp-back-to-top').addClass('d-none').removeClass('d-flex');
    }, 3000);
    checkDivsBackToTop();
});

$('.plp-back-to-top').on('click', function () {
    scrollAnimate();
});
